<template>
    <BaseCard :data="data" :hideBorder="true">
        <div slot="details" class="details-container">
            <div class="details-item">
                <font-awesome-icon class="gray-color details-icon" icon="calendar" />
                {{ startDate }}
            </div>
            <div class="details-item">
                <font-awesome-icon class="gray-color details-icon" icon="clock" />
                {{ startTime }} - {{ endTime }}
            </div>
            <div v-if="data.location" v-b-tooltip.hover class="details-item" :title="data.location">
                <font-awesome-icon class="gray-color details-icon" icon="map-marker-alt" />

                {{ data.location }}
            </div>
        </div>

        <div slot="actions" class="actions-container align-items-center">
            <div class="action-item">
                <div class="event-status">{{ status }}</div>
            </div>
            <div class="action-item">
                <Button variant="" @click="cancelBooking()">
                    <font-awesome-icon class="gray-color" icon="trash" />
                </Button>
            </div>
        </div>
    </BaseCard>
</template>

<script>
import dateToString from '~/utils/dateToString';
import moment from 'moment';
import tz from 'moment-timezone';

// Components
import Button from '~/components/builders/Base/Button';
import Icon from '~/components/builders/Base/Icon';
import BaseCard from './BaseCard';

// Services
import AnalyticService from '~/services/AnalyticService';
import CalendarService from '~/services/CalendarService';
import DialogService from '~/services/DialogService';
import MessageService from '~/services/MessageService';

export default {
    name: 'BookedAppointmentCard',
    components: {
        Button,
        BaseCard,
    },
    props: {
        data: {
            type: Object,
            default: () => {},
        },
    },
    data: () => ({
        hasLoggedAppointmentClickEvent: false,
        calendarService: new CalendarService(),
    }),
    computed: {
        status() {
            switch (this.data.status) {
                case 'accepted':
                    return this.$t('calendar.bookingStatus.accepted');
                case 'pending':
                    return this.$t('calendar.bookingStatus.pending');
                case 'declined':
                    return this.$t('calendar.bookingStatus.declined');
                case 'tentative':
                    return this.$t('calendar.bookingStatus.tentative');
            }
            return this.$t('calendar.bookingStatus.pending');
        },
        startDate() {
            return dateToString(this.data.start_time, true, true);
        },
        startTime() {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            return moment(this.data.start_time)
                .tz(timeZone)
                .format('LT a');
        },
        endTime() {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            return moment(this.data.end_time)
                .tz(timeZone)
                .format('LT a z');
        },
    },
    methods: {
        async logAppointmentTypeClickEvent() {
            if (this.hasLoggedAppointmentClickEvent || !this.data.id) return;
            AnalyticService.appointmentTypeClickEvent(this.data.id);
            this.hasLoggedAppointmentClickEvent = true;
        },
        cancelBooking() {
            const onDelete = ({ res }) => {
                this.calendarService
                    .cancelBooking(this.data.id)
                    .then(() => {
                        res();
                    })
                    .catch(() => {
                        MessageService.error(
                            this.$t('calendar.deleteBookModal.error.title'),
                            this.$t('calendar.deleteBookModal.error.description')
                        );
                    });
            };

            const onCancel = ({ res }) => {
                res();
            };

            return DialogService.openAppointmentDeleteBookingDialog(onCancel, onDelete);
        },
    },
};
</script>

<style scoped>
.details-container {
    display: flex;
    flex-direction: column;
}

.details-item {
    padding-right: 1rem;
    padding-bottom: 0.5rem;
    display: grid;
    grid-template-columns: 0.1fr 1fr;
    align-items: center;

    word-break: break-all;
}

.details-icon {
    justify-self: center;
}

.actions-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.action-item {
    padding-right: 1em;
    align-items: center;
}
</style>
